import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import cookies from '../../config/cookies/cookies';
import { updateTrackingLocation } from '../../helpers/analytics';
import { setCookie } from '../../helpers/cookieSetter';
import { onSelectLocationHelper } from '../../helpers/location';
import { setLocation } from '../../redux/actions/locations';
import { getGeoLocationData } from '../../services/geoLocation';

const GeoLocation = () => {
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function ({
      coords: { latitude, longitude },
    }) {
      const setUserSelectedLocation = async () => {
        try {
          // Fetch geolocation data
          const data = await getGeoLocationData(latitude, longitude);

          // Ensure the cookie is set before proceeding
          await setCookie({
            expire: 365,
            key: cookies.googleLocation,
            value: 'b',
          });

          if (data) {
            // Dispatch location to Redux store
            dispatch(setLocation(data, true));

            // Call helper functions for further processing
            onSelectLocationHelper(data, dispatch, router, false, true);

            // Update analytics with the tracking location
            updateTrackingLocation(data.name, 'geo_located');
          }
        } catch (error) {
          console.error('Error setting user location:', error);
        }
      };

      setUserSelectedLocation();
    });
  }, [dispatch, router]);

  return <></>;
};

export default GeoLocation;
